// Mini App API helper — base URL, JWT header, error unwrapping.
// ── API Helper ───────────────────────────────────────────────────────────────
export const API_BASE = import.meta.env.VITE_API_URL || "";

export async function api(path, options = {}) {
  const token = sessionStorage.getItem("jwt");
  const headers = { ...options.headers };
  if (token) headers["Authorization"] = `Bearer ${token}`;
  if (options.body && !(options.body instanceof FormData)) {
    headers["Content-Type"] = "application/json";
  }
  // ⚠️ A GET of private JSON gets a unique query AND `cache: "no-store"`: a CDN in front of
  // the origin ("wcdn", cache policy SMART) cached /children by URL alone and served one
  // family's children to another (2026-10-18). nginx now forbids storing it too; this makes
  // sure no cache can ever MATCH a private response even if one stores it.
  const method = (options.method || "GET").toUpperCase();
  const url = method === "GET" ? `${API_BASE}${path}${path.includes("?") ? "&" : "?"}_=${Date.now().toString(36)}${Math.random().toString(36).slice(2, 7)}` : `${API_BASE}${path}`;
  const resp = await fetch(url, { cache: "no-store", ...options, headers });
  if (!resp.ok) {
    const err = await resp.json().catch(() => ({ detail: resp.statusText }));
    throw new Error(err.detail || `API error ${resp.status}`);
  }
  if (resp.status === 204) return null;
  return resp.json();
}

